import React, { Component } from "react";
import { Row, Col, Button, Container, FormGroup, Alert } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  registerTrialUser,
  registerTrialUserFailed,
  registerTrialUserSuccessful,
  //apiError,
} from "../store/actions";
import { connect } from "react-redux";
import { countryList } from "../utilities/countries";
import logodark from "../assets/images/cloudcatcher_logo.png";
import cloudnovalogo from "../assets/images/logo-main-white.png";
import Recaptcha from "react-recaptcha";

const CONFIRMATION_PAGE =
  process.env.REACT_APP_TRIAL_REGISTER_CONFIRMATION_PAGE;

class TrialRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserVerified: false,
      captchaError: false,
      activeTabProgress: 1,
      userFirstName: "",
      userLastName: "",
      userEmail: "",
      userPhone: "",
      userAddress: "",
      userZipcode: "",
      userCountry: "",
      userProvince: "",
      userCity: "",
      companyName: "",
      userComments: "",
      TrialRegiError: false,
      isOpen: false,
      confirmation: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {
    document.body.scroll = "no";
    document.body.style.overflow = "auto";
    document.height = window.innerHeight;
    document.body.classList.add("auth-body-bg");
  }

  verifyCallback = (response) => {
    if (response) {
      this.setState({ isUserVerified: true });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "userPhone") {
      const formatNum = value
        .replace("-", "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      this.setState({ [name]: formatNum });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  componentDidUpdate(prevProps) {}

  handleSubmit = () => {
    if (
      this.state.isUserVerified &&
      !this.state.userCity.match(/\d+/g) &&
      !this.state.userProvince.match(/\d+/g)
    ) {
      this.props.registerTrialUser(this.state);
      this.setState({ confirmation: true });
    } else {
      this.setState({ captchaError: true });
    }
  };

  handleConfirmation = () => {
    if (this.props.userError == null && this.state.isUserVerified) {
      // window.location.href = CONFIRMATION_PAGE;
      window.location.href = "/confirmation";
    }
  };

  isInvalid = () => {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
    const isInvalidItems = [
      {
        field: "userFirstName",
        isInvalid: this.state.userFirstName === "" ? true : false,
      },
      {
        field: "userLastName",
        isInvalid: this.state.userLastName === "" ? true : false,
      },
      {
        field: "userEmail",
        isInvalid:
          (this.state.userEmail && this.state.userEmail.length === 0) ||
          !regex.test(String(this.state.userEmail).toLowerCase()),
      },
      {
        field: "userPhone",
        value: this.state.userPhone,
        isInvalid:
          this.state.userPhone.length !== 12 ||
          !phoneRegex.test(this.state.userPhone)
            ? true
            : false,
      },
      {
        field: "userAddress",
        isInvalid: this.state.userAddress.length === 0 ? true : false,
      },
      {
        field: "userZipcode",
        value: this.state.userZipcode,
        isInvalid:
          this.state.userZipcode.length !== 5 ||
          !/^[0-9a-zA-Z]+$/.test(this.state.userZipcode)
            ? true
            : false,
      },
      {
        field: "userCity",
        isInvalid: this.state.userCity.length === 0 ? true : false,
      },
    ];
    const resp = isInvalidItems.filter((item) => item.isInvalid);
    console.log(
      "--== isInvalid <:::> phonenumber ",
      this.state.phonenumber,
      isInvalidItems,
      resp
    );

    return resp.length > 0;
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="p-0">
          <Row className="no-gutters">
            <Col lg={7}>
              <div className="authentication-bg auth-org-reg image-layer">
                <div className="info-card">
                  <h1 className="demo-title">Request a Demo</h1>
                  <h5 className="demo-subtitle-1">
                    Are you ready to experience the power of CloudCatcher in
                    action?
                  </h5>
                  <ul className="demo-highlights">
                    <li>
                      <span style={{ fontWeight: "bold", color: "#E36D25" }}>
                        Cloud Asset Visibility:{" "}
                      </span>{" "}
                      CloudCatcher Asset Insight provides a complete view of
                      cloud assets across all accounts on AWS Cloud Platform.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold", color: "#E36D25" }}>
                        Continuous Cloud Security Posture Management (CSPM):{" "}
                      </span>
                      CloudCatcher's automated cloud security posture management
                      provides the ability to identify security gaps,
                      vulnerabilities, configuration mismanagement and provides
                      remediation steps to maintain the security posture of the
                      cloud assets at all times.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold", color: "#E36D25" }}>
                        Continuous Compliance Monitoring:{" "}
                      </span>
                      CloudCatcher's automated compliance monitoring provides
                      the ability to identify non-compliant assets.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold", color: "#E36D25" }}>
                        Near Real-time Event Analysis:{" "}
                      </span>
                      CloudCatcher Event Insights provides the ability to
                      monitor and analyze cloud events in near real-time to
                      respond to security incidents. Detect unauthorized access
                      attempts, unusual activity, and potential indicators of
                      compromise, all within a single unified dashboard.
                      Advanced threat detection capabilities and robust threat
                      hunting tools are integrated to proactively safeguard
                      cloud environments.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold", color: "#E36D25" }}>
                        Proactive Threat Detection:{" "}
                      </span>
                      CloudCatcher's threat detection capabilities enable the
                      identification of security threats in near real-time,
                      ensuring the safety and integrity of your cloud
                      environment.
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold", color: "#E36D25" }}>
                        Cost Spend Optimization:{" "}
                      </span>
                      CloudCatcher Cost Optimization provides the ability to
                      analyze resource cost by identifying under or unutilized
                      resources, analyze usage patterns, and make informed
                      decisions to optimize cloud infrastructure costs.
                    </li>
                  </ul>
                  <h5 className="demo-subtitle-1">
                    Request your personalized demo today and let our experts
                    guide you through its powerful features and capabilities.
                  </h5>
                </div>
                <br />
                <div className="logo-container">
                  <img src={cloudnovalogo} height="60" alt="logo" />
                </div>
              </div>
            </Col>
            <Col lg={5}>
              <div className="authentication-page-content auth-org-reg p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div>
                        <div className="text-center">
                          <div>
                            <img src={logodark} height="60" alt="logo" />
                          </div>
                          <br />
                          {this.props.userError != null &&
                          this.props.userError ? (
                            <Alert className="mt-3 mb-0" color="danger">
                              User with those credentials already exists!
                            </Alert>
                          ) : null}
                        </div>

                        <div id="progrss-wizard" className="twitter-bs-wizard">
                          <AvForm className="form-horizontal">
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userFirstName"
                                    value={this.state.userFirstName}
                                    placeholder="First Name"
                                    type="text"
                                    id="basicpill-UserFirstName-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter First Name"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "First name is required",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userLastName"
                                    value={this.state.userLastName}
                                    placeholder="Last Name"
                                    type="text"
                                    id="basicpill-UserLastName-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter last name"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "Last name is required",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userPhone"
                                    value={this.state.userPhone}
                                    placeholder="Phone"
                                    type="text"
                                    id="basicpill-UserPhone-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter Phone"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage:
                                          "Phone number is required",
                                      },
                                      pattern: {
                                        value: "[0-9]",
                                        errorMessage:
                                          "Please enter a valid phone number",
                                      },
                                      minLength: {
                                        value: 12,
                                        errorMessage:
                                          "Phone number must be 10 digits",
                                      },
                                      maxLength: {
                                        value: 12,
                                        errorMessage:
                                          "Phone number must be 10 digits",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userEmail"
                                    value={this.state.userEmail}
                                    placeholder="Work Email"
                                    type="text"
                                    id="basicpill-UserEmail-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter email"
                                    validate={{
                                      pattern: {
                                        value:
                                          "/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/",
                                        errorMessage:
                                          "Must be a valid Email Address",
                                      },
                                      email: true,
                                      required: true,
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <FormGroup>
                                  <AvField
                                    name="companyName"
                                    value={this.state.companyName}
                                    placeholder="Company Name"
                                    type="text"
                                    id="companyName"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter company name"
                                    validate={{
                                      required: {
                                        companyName: true,
                                        errorMessage: "Company name required",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <FormGroup>
                                  <AvField
                                    name="userAddress"
                                    value={this.state.userAddress}
                                    placeholder="Address"
                                    type="text"
                                    id="basicpill-userAddress-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter address"
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "Address is required",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userCity"
                                    value={this.state.userCity}
                                    placeholder="City"
                                    type="text"
                                    id="basicpill-userCity-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter a city"
                                    validate={{
                                      required: {
                                        userCity: true,
                                        errorMessage: "City required",
                                      },
                                      pattern: {
                                        value: "/^[a-zA-Z]+$/",
                                        errorMessage: "Must be a valid City",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userProvince"
                                    value={this.state.userProvince}
                                    placeholder="State / Territory"
                                    type="text"
                                    id="basicpill-userProvince-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter a state / territory"
                                    validate={{
                                      required: {
                                        userProvince: true,
                                        errorMessage:
                                          "State / Territory required",
                                      },
                                      pattern: {
                                        value: "/^[a-zA-Z]+$/",
                                        errorMessage:
                                          "Must be a valid State / Territory",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FormGroup>
                                  <AvField
                                    name="userZipcode"
                                    value={this.state.userZipcode}
                                    placeholder="Zip Code"
                                    type="text"
                                    id="basicpill-userZipcode-input"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    errorMessage="Enter a Zip Code"
                                    validate={{
                                      required: {
                                        userZip: true,
                                        errorMessage: "Zip Code required",
                                      },
                                      pattern: {
                                        value: "^[0-9a-zA-Z]+$",
                                        errorMessage:
                                          "Please enter a valid phone number",
                                      },
                                    }}
                                    maxLength="5"
                                  />
                                </FormGroup>
                              </Col>
                              <Col lg="12">
                                <FormGroup>
                                  <AvField
                                    type="select"
                                    name="userCountry"
                                    id="basicpill-userCountry-input"
                                    className={"form-control"}
                                    value={this.state.userCountry}
                                    onChange={this.handleInputChange}
                                  >
                                    {countryList.map((country) => {
                                      return (
                                        <option key={country}>{country}</option>
                                      );
                                    })}
                                  </AvField>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <FormGroup>
                                  <textarea
                                    name="userComments"
                                    value={this.state.userComments}
                                    type="input"
                                    lineheight="1.2em"
                                    id="userComments"
                                    placeholder="User Comments (optional)"
                                    className={"form-control"}
                                    onChange={this.handleInputChange}
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: "Comments are required",
                                      },
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row
                              style={{
                                margin: "auto",
                                width: "auto",
                                height: "auto",
                              }}
                            >
                              <Col lg="6">
                                <Recaptcha
                                  sitekey={
                                    process.env.REACT_APP_RECAPTCHA_SITE_KEY
                                  }
                                  render="explicit"
                                  onloadCallback={() => {}}
                                  ref={(e) => (this.recaptchaInstance = e)}
                                  verifyCallback={this.verifyCallback}
                                  size="compact"
                                />
                              </Col>
                            </Row>
                            <Row />
                            &nbsp;
                            <Row className="justify-content-center">
                              <Col lg="6" className="text-center">
                                <FormGroup>
                                  <Button
                                    color="primary"
                                    className="w-md waves-effect waves-light"
                                    type="submit"
                                    disabled={this.isInvalid()}
                                    //onValidSubmit={this.handleSubmit}
                                    onClick={() => {
                                      this.handleSubmit();
                                      setTimeout(this.handleConfirmation, 800);
                                    }}
                                  >
                                    Request a Demo
                                  </Button>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AvForm>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { message, userError, loading } = state.trialuser;
  return { message, userError, loading };
};

export default connect(mapStatetoProps, {
  registerTrialUser,
  registerTrialUserFailed,
  registerTrialUserSuccessful,
})(TrialRegister);
